import React from 'react';

interface SkuAutocompleteInputProps {
  inputRef?: React.Ref<HTMLInputElement>;
  autocompleteRef?: React.Ref<HTMLDivElement>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  showAutocomplete: boolean;
  filteredSkus: string[];
  selectedIndex: number;
  onSelectSku: (sku: string) => void;
  onHoverIndex: (index: number) => void;
}

function SkuAutocompleteInput({
  inputRef,
  autocompleteRef,
  value,
  onChange,
  onKeyDown,
  onKeyPress,
  placeholder,
  showAutocomplete,
  filteredSkus,
  selectedIndex,
  onSelectSku,
  onHoverIndex,
}: SkuAutocompleteInputProps) {
  return (
    <div className="pbl-sku-input-wrapper">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className="pbl-sku-input"
        onKeyPress={onKeyPress}
      />
      {showAutocomplete && filteredSkus.length > 0 && (
        <div ref={autocompleteRef} className="pbl-autocomplete-dropdown">
          {filteredSkus.map((sku, index) => (
            <div
              key={sku}
              className={`pbl-autocomplete-item ${index === selectedIndex ? 'selected' : ''}`}
              onClick={() => onSelectSku(sku)}
              onMouseEnter={() => onHoverIndex(index)}
            >
              {sku}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SkuAutocompleteInput;
